"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
var adminSlice_1 = __importDefault(require("./slice/adminSlice"));
var aboutSlice_1 = __importDefault(require("./slice/aboutSlice"));
var banksListSlice_1 = __importDefault(require("./slice/banksListSlice"));
var carsSlice_1 = __importDefault(require("./slice/carsSlice"));
var contactsSlice_1 = __importDefault(require("./slice/contactsSlice"));
var editCarSlice_1 = __importDefault(require("./slice/editCarSlice"));
var favoritesSlice_1 = __importDefault(require("./slice/favoritesSlice"));
var filterSlice_1 = __importDefault(require("./slice/filterSlice"));
var inStockSlice_1 = __importDefault(require("./slice/inStockSlice"));
var lastArrivalSlice_1 = __importDefault(require("./slice/lastArrivalSlice"));
var popularCarSlice_1 = __importDefault(require("./slice/popularCarSlice"));
var mediaQuerySlice_1 = __importDefault(require("./slice/mediaQuerySlice"));
var modalSlice_1 = __importDefault(require("./slice/modalSlice"));
var paymentSlice_1 = __importDefault(require("./slice/paymentSlice"));
var sortCarsSlice_1 = __importDefault(require("./slice/sortCarsSlice"));
var catalogCarSlice_1 = __importDefault(require("./slice/catalogCarSlice"));
var toolkit_1 = require("@reduxjs/toolkit");
var store = (0, toolkit_1.configureStore)({
    reducer: {
        admin: adminSlice_1.default,
        about: aboutSlice_1.default,
        banksList: banksListSlice_1.default,
        cars: carsSlice_1.default,
        contacts: contactsSlice_1.default,
        editCar: editCarSlice_1.default,
        favorites: favoritesSlice_1.default,
        filter: filterSlice_1.default,
        inStockList: inStockSlice_1.default,
        lastArrivalsList: lastArrivalSlice_1.default,
        mediaQuery: mediaQuerySlice_1.default,
        modal: modalSlice_1.default,
        popularCarsList: popularCarSlice_1.default,
        payment: paymentSlice_1.default,
        sortCars: sortCarsSlice_1.default,
        catalogCar: catalogCarSlice_1.default,
    },
});
exports.store = store;
